export enum NotificationSettingsType {
  ChangeOnboardingStatus = 'ChangeOnboardingStatus',
}

export interface NotificationSettingsData {
  type: NotificationSettingsType;
  isEmailEnabled: boolean;
  isBellEnabled: boolean;
}
